export * from '@/lib/i18n/index';
export { default } from '@/lib/i18n/index';


